import { Component, OnInit } from '@angular/core';

import { IPageComponent } from '~Interfaces/ipagecomponent';

/**
 * Composant d'administration
 * @implements IPageComponent
 * @extends OnInit
 */
@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent extends IPageComponent implements OnInit {

    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

}
